export default __webpack_public_path__ + "static/media/card-angled.646222b5.png";